import parsePhoneNumber from 'libphonenumber-js';
import { filter, map } from 'lodash';
import { getRawPhoneNumber } from 'utils/formatters';
import { EMAIL_COX_REGEX, EMAIL_REGEX } from 'utils/pattern';
import * as yup from 'yup';

export const AddressSchema = yup.object().shape({
  address1: yup.string('must be a string').required('address is required'),
  address2: yup.string('must be a string'),
  city: yup.string('must be a string').required('city is required'),
  stateProvince: yup.string('must be a string').required('state is required'),
  zipPostalCode: yup.string('must be a string').required('zipcode is required'),
  // country: yup.string('must be a string').required('country is required'),
});

export const ContactEmailSchema = yup.object().shape({
  contactValue: yup
    .string()
    .email('Invalid Email Address')
    .required('This field is required'),
});

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const ContactNumberSchema = yup.object().shape({
  contactValue: yup
    .string()
    .matches(phoneRegExp, { message: 'Phone number is not valid' })
    .required('This field is required'),
});

export const ContactSchema = yup.object().shape({
  value: yup.string().required(),
  //  contactValue: yup.string().when('contactType', {
  //    is: val => val.toLowerCase().indexOf('email') > -1,
  //    then: yup
  //      .string()
  //      .email('Invalid Email')
  //      .required('This field is required'),
  //    otherwise: yup
  //      .string()
  //      .matches(phoneRegExp, { message: 'Phone number is not valid' })
  //      .required('This field is required'),
  //  }),
});

export const validateContact = (type, value) => {
  // return isPhone ? validatePhone(value) : validateEmail(value);

  if (type === 'phone') return validatePhone(value);
  else if (type === 'mail') return validateEmail(value);

  return true;
};

export const validateCoxEmail = (value) => {
  return EMAIL_COX_REGEX.test(value);
};

export const validateEmail = (value, message = 'Invalid email address') => {
  const isValid = EMAIL_REGEX.test(value);
  if (!isValid) return message;

  return true;
};

export const validatePhone = (value, message = 'Invalid phone number') => {
  const phoneNumber = parsePhoneNumber(value, 'US');
  const isValid = phoneNumber?.isPossible();
  if (!isValid) return message;

  return true;
};

export const validateDuplicateContact = (fields, value) => {
  if (isHadDuplicatedValues(fields, value)) {
    return 'Duplicates are not allowed';
  }
  return true;
};

export const isHadDuplicatedValues = (fields, value) => {
  let fieldsObjs = {};
  const maxRepeatTimes = 2;

  for (let i = 0; i < fields.length; i++) {
    const temp = fields[i].value.toLowerCase();
    if (!fieldsObjs[temp]) {
      fieldsObjs[temp] = 0;
    }
    fieldsObjs[temp]++;

    if (fieldsObjs[value] >= maxRepeatTimes) return true;
  }

  return false;
};

export const validateEmailPatternAndDuplicate = (
  fields,
  value,
  index,
  patternMess = 'Please enter a valid email address'
) => {
  const isValueDeleted = fields?.[index]?.deleted;
  if (isValueDeleted) return true;

  const validatePatternResult = validateEmail(value, patternMess);
  if (validatePatternResult !== true) return validatePatternResult;

  const nonDeletedValues = filter(fields, (v) => !v.deleted);
  return validateDuplicateContact(nonDeletedValues, value.toLowerCase());
};

export const validatePhonePatternAndDuplicate = (
  fields,
  value,
  index,
  patternMess = 'Please enter a valid phone number'
) => {
  let phoneNumber = getRawPhoneNumber(value);
  const isValueDeleted = fields?.[index]?.deleted;
  if (isValueDeleted) return true;

  const validatePatternResult = validatePhone(value, patternMess);
  if (validatePatternResult !== true) return validatePatternResult;

  let nonDeletedValues = filter(fields, (v) => {
    return !v.deleted;
  });

  nonDeletedValues = map(nonDeletedValues, (v) => {
    const phoneParsed = getRawPhoneNumber(v?.value);
    return {
      ...v,
      value: phoneParsed,
    };
  });

  return validateDuplicateContact(nonDeletedValues, phoneNumber);
};

export const isPhone = /PRIMARY_MAIN_PHONE|MAIN_PHONE|CELL|PRIMARY_CELL|PREFERRED_PHONE/i;
export const isEmail = /PRIMARY_EMAIL|EMAIL|PREFERRED_EMAIL/i;
export const isListingPhone = /LISTING_PHONE/i; // this is taken care in the above isPhone pattern, being added to be consistent with email 
export const isListingEmail = /LISTING_EMAIL/i;